import classNames from 'classnames';
import map from 'lodash/map';
import noop from 'lodash/noop';
import partial from 'lodash/partial';
import { Accordion } from 'react-accessible-accordion';

import type { CapsuleAccordionProps } from 'src/app/types';

import { AccordionItemWrapper } from './AccordionItemWrapper';
import styles from './styles.module.scss';

export const CapsuleAccordion = ({
  bodyClassName,
  className,
  expandCallback = noop,
  hideLines,
  hideOnlyFirstLine,
  // name, TODO: will be added by Pat in a future aria PR
  expandFirstQuestion = false,
  questions,
  titleClassName,
  wrapperClassName,
  buttonClassName,
  headingClassName,
  headerTopMargin = false,
  whiteAccordion,
  useBlueThemedAccordion,
  sectionHeaderLevel,
  useV2Styles,
}: CapsuleAccordionProps) => {
  return (
    <Accordion
      className={classNames(
        useBlueThemedAccordion || useV2Styles ? 'fullWidthAccordion' : 'accordion',
        styles.component,
        className
      )}
      onChange={partial(expandCallback, questions)}
      allowZeroExpanded={true}
      preExpanded={expandFirstQuestion ? ['0'] : []}
      allowMultipleExpanded={false}
    >
      {map(questions, (q, i) => (
        <AccordionItemWrapper
          uuid={`${i}`}
          question={q.question}
          answer={q.answer}
          key={`${i}-${q.question}`}
          hideLines={hideLines}
          hideOnlyFirstLine={hideOnlyFirstLine}
          wrapperClassName={wrapperClassName}
          titleClassName={titleClassName}
          buttonClassName={buttonClassName}
          bodyClassName={bodyClassName}
          whiteAccordion={whiteAccordion}
          headingClassName={headingClassName}
          headerTopMargin={headerTopMargin}
          useBlueThemedAccordion={useBlueThemedAccordion}
          sectionHeaderLevel={sectionHeaderLevel}
          useV2Styles={useV2Styles}
        />
      ))}
    </Accordion>
  );
};
